import * as types from '@/store/types.js'

const state = {
  activeLanguage: 'hr',
  defaultLanguage: 'hr',
  languages: [
    {
      iso: 'hr',
      name: 'Croatian'
    },
    {
      iso: 'en',
      name: 'English'
    }
  ]
}

// GETTERS
const getters = {
  [types.ACTIVE_LANGUAGE]: state => state.activeLanguage,
  [types.DEFAULT_LANGUAGE]: state => state.defaultLanguage,
  [types.LANGUAGES]: state => state.languages
}

// ACTIONS
const actions = {
  [types.ACTIVE_LANGUAGE]: ({ commit }, value) => {
    commit(types.ACTIVE_LANGUAGE, value)
  }
}

// MUTATIONS
const mutations = {
  [types.ACTIVE_LANGUAGE] (state, value) {
    state.activeLanguage = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Settings.js